export default {
  title: 'Enlaces',

  short: {
    title: 'Enlaces cortos'
  },

  domains: {
    title: 'Dominios'
  },

  presets: {
    title: 'Preajustes'
  },

  tracking: {
    title: 'Transiciones'
  }
}
